export default __webpack_public_path__ + "locales/de/PreparationPortal.json?hash=c19cfddc0f1ca0b33d94befbb297577e";